"use strict";
// FICO score sentinel values returned by Experian's FICO 9 model in place of a real score.
// See the FICO9 manual: https://drive.google.com/file/d/1_c2THjW5QHsB9hDXY0VLkPX2BnBURatn/view
//
// These values fall outside the valid FICO range (300-850) and represent why a
// score could not be produced. The single source of truth lives here and is
// auto-translated to Python via translateToPython.js.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFicoScore = exports.classifyFicoScore = exports.FicoClassificationKind = exports.MAX_VALID_VANTAGE_SCORE = exports.MIN_VALID_VANTAGE_SCORE = exports.MAX_VALID_FICO_SCORE = exports.MIN_VALID_FICO_SCORE = exports.FICO_SENTINEL_VALUE = exports.FicoSentinel = void 0;
/** @TranslateToPython */
var FicoSentinel;
(function (FicoSentinel) {
    FicoSentinel["TOO_MANY_TRADELINES"] = "TOO_MANY_TRADELINES";
    FicoSentinel["DECEASED"] = "DECEASED";
    FicoSentinel["NO_TRADELINES"] = "NO_TRADELINES";
    FicoSentinel["THIN_FILE"] = "THIN_FILE";
})(FicoSentinel || (exports.FicoSentinel = FicoSentinel = {}));
/** @TranslateToPython */
exports.FICO_SENTINEL_VALUE = {
    [FicoSentinel.TOO_MANY_TRADELINES]: 9000,
    [FicoSentinel.DECEASED]: 9001,
    [FicoSentinel.NO_TRADELINES]: 9002,
    [FicoSentinel.THIN_FILE]: 9003,
};
/** @TranslateToPython */
exports.MIN_VALID_FICO_SCORE = 300;
/** @TranslateToPython */
exports.MAX_VALID_FICO_SCORE = 850;
/** @TranslateToPython */
exports.MIN_VALID_VANTAGE_SCORE = 300;
/** @TranslateToPython */
exports.MAX_VALID_VANTAGE_SCORE = 850;
const NUMERIC_VALUE_TO_SENTINEL = new Map(Object.entries(exports.FICO_SENTINEL_VALUE).map(([sentinel, value]) => [value, sentinel]));
var FicoClassificationKind;
(function (FicoClassificationKind) {
    FicoClassificationKind["Score"] = "score";
    FicoClassificationKind["Sentinel"] = "sentinel";
    FicoClassificationKind["Unavailable"] = "unavailable";
})(FicoClassificationKind || (exports.FicoClassificationKind = FicoClassificationKind = {}));
/**
 * Classify a raw FICO score from a credit report. Returns structured data only —
 * callers own rendering (e.g. partner UIs render sentinel labels via i18n;
 * consumer disclosures collapse sentinels to "unavailable" for FCRA-safe phrasing).
 * - Valid scores (300-850) → { kind: 'score', value }
 * - Known sentinels (9000-9003) → { kind: 'sentinel', sentinel }
 * - Null / unparseable / out-of-range → { kind: 'unavailable' }
 */
const classifyFicoScore = (rawScore) => {
    if (rawScore === null || rawScore === undefined || rawScore === '') {
        return { kind: FicoClassificationKind.Unavailable };
    }
    const numericValue = Math.trunc(Number(rawScore));
    if (!Number.isFinite(numericValue)) {
        return { kind: FicoClassificationKind.Unavailable };
    }
    const sentinel = NUMERIC_VALUE_TO_SENTINEL.get(numericValue);
    if (sentinel !== undefined) {
        return { kind: FicoClassificationKind.Sentinel, sentinel };
    }
    if (numericValue >= exports.MIN_VALID_FICO_SCORE && numericValue <= exports.MAX_VALID_FICO_SCORE) {
        return { kind: FicoClassificationKind.Score, value: numericValue };
    }
    return { kind: FicoClassificationKind.Unavailable };
};
exports.classifyFicoScore = classifyFicoScore;
const isValidFicoScore = (rawScore) => (0, exports.classifyFicoScore)(rawScore).kind === FicoClassificationKind.Score;
exports.isValidFicoScore = isValidFicoScore;
